module.exports = __webpack_public_path__ + "img/wave.33407cff.png";